import { render, staticRenderFns } from "./MarcadorImagem.vue?vue&type=template&id=d516012a&scoped=true&"
import script from "./MarcadorImagem.vue?vue&type=script&lang=js&"
export * from "./MarcadorImagem.vue?vue&type=script&lang=js&"
import style0 from "./MarcadorImagem.vue?vue&type=style&index=0&id=d516012a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d516012a",
  null
  
)

export default component.exports